export default "__VITE_ASSET__C0vB3dV3__"